import { render, staticRenderFns } from "./countryRiskDetail.vue?vue&type=template&id=399504fa&scoped=true&"
import script from "./countryRiskDetail.vue?vue&type=script&lang=js&"
export * from "./countryRiskDetail.vue?vue&type=script&lang=js&"
import style0 from "./countryRiskDetail.vue?vue&type=style&index=0&id=399504fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399504fa",
  null
  
)

export default component.exports